angular.module(NgAppName).component("crMosaic", {
	templateUrl: "crMosaic.html",
	transclude: true,
	bindings: {
		eventToCallOnImageClick: "@",
		eventToCallOnVideoClick: "@",
	},
	controller: ["$element", "$timeout", "PubSub", function($element, $timeout, PubSub) {
		var self = this;

		this.init = function() {
			this.slides = angular.element($element[0].querySelectorAll('.slide-image'));
			this.slideFloorplan = angular.element($element[0].querySelectorAll('.slide-floorplan'));

			// check the slides and add properties/callbacks
			for (var i = 0; i < this.slides.length; i++) {
				let ind = i;

				// bind click on images
				if (this.eventToCallOnImageClick && !angular.element(this.slides[i]).hasClass("no-popup")) {
					angular.element(this.slides[i]).bind('click', (function(index) {
						return function() {
							self.imageClick(index);
						};
					}(ind)));
				}

			}

		};

		this.imageClick = function(index) {
			PubSub.publish(this.eventToCallOnImageClick, index);
		};

		this.$postLink = function () {
			$timeout(() => {
				this.init();
			});
	 	};
	}]
});